<template>
  <div style='position: relative'>
    <div class="favorite-list-item" :class='{"select-hover": isOrdering}' @click="handleInput(address.favoriteLocationId)">
      <div v-if='isOrdering' style='padding-left: 4px; display: flex'>
        <CustomRadioButton
          :radioId='"id" + address.favoriteLocationId'
          :inputValue='address.favoriteLocationId'
          v-bind:value='addressSelectedId'
          v-on:input='handleInput'
          label=' '
        />
      </div>
      <img v-else-if='address.addressType === 1' src='~@/assets/img/icon/pin-15.svg'>
      <img v-else-if='address.addressType === 2' src='~@/assets/img/icon/store-1.svg'>
      <div class='registerName-and-button' :class='{ notLastEl: addressList.length !== elKey + 1 }'>
        <div style='flex: 1 1 0; display: flex; flex-direction: column; gap: 4px;'>
          <div v-if='address.isPredetermined'>
            <div class='text-xs-bold register-predetermined'>
              <Icon name='Star' :size='16' strokeColor='#490050' />
              {{ address.puntoScharffId ? 'Punto Sharf predeterminado' : 'Domicilio predeterminado'}}</div>
          </div>
          <div v-if='address.puntoScharffId'>
            <div class='text-m-regular'>{{ address.puntoScharffName }}</div>
            <div class='text-m-regular'>{{ address.address }}</div>
            <div class='text-m-regular'>{{ address.departmentName }}, {{ address.provinceName }}, {{ address.districtName }}</div>
          </div>
          <div v-else class='text-m-regular'>{{ address.address }}</div>
          <div v-if='address.name' class='text-s-regular' style='color: #737373'>{{ address.name }}</div>
          <div v-if='!address.location.Lat || !address.location.Lng' class='text-xs-bold register-warning' @click='handleEdit()'>
            <Icon name='Pin' variant='bold' :size='16' fillColor='#FFF' />
            Necesita punto en mapa. Click para añadir 
          </div>
        </div>
        <div class='dropdown-button' @click='toggleOpen()'>
          <img src='~@/assets/img/icon/menu_1.svg'>
        </div>
      </div>
    </div>
    <div class='menu_drop_down' v-if='isOpenDropDown' ref='dropdown'>
      <div style='border-bottom: solid 1px #D0D0D0' class='option' @click='handleEdit()'>
        <img src='~@/assets/img/icon/edit-square.svg'>
        <div>Editar</div>
      </div>
      <div class='option' @click='handleDelete()'>
        <img src='~@/assets/img/icon/delete.svg'>
        <div style='color: #CC454A'>Eliminar</div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomRadioButton from '../Form/CustomRadioButton.vue'
import Icon from '@/components/Icon.vue'

  export default {
    components: {
      CustomRadioButton,
      Icon
    },
    props: {
      isOrdering: {
        type: Boolean,
        default: false
      },
      addressSelectedId: {
        type: Number,
        default: 0
      },
      address: {
        type: Object,
        default: {}
      },
      elKey: {
        type: Number
      },
      addressList: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        isOpenDropDown: false
      }
    },
    methods: {
      handleInput(e) {
        if(this.isOrdering){
          this.$emit('handleSelectAddress', e)
        }
      },
      toggleOpen() {
        setTimeout(() => {
          this.isOpenDropDown = true
        }, 50)
      },
      handleEdit() {
        this.$emit('editAction', this.address)
      },
      handleDelete() {
        this.$emit('deleteAction', this.address)
      },
      handleClickOutside(event) {
        const dropdown = this.$refs.dropdown
        if (dropdown && !dropdown.contains(event.target) && this.isOpenDropDown) {
          this.isOpenDropDown = false
        }
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside)
    },
  }
</script>

<style lang='scss' scoped>
  .registerName-and-button {
    width: 100%;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    display: flex;

    &.notLastEl {
      border-bottom: solid 1px #D0D0D0;
    }

    .register-predetermined {
      display: flex;
      gap: 4px;
      align-items: center;
      width: fit-content;
      padding: 4px 8px;
      border-radius: 360px;
      background-color: #EEBAFF;
      border: none;
      color: #490050;
    }
    .register-warning {
      display: flex;
      align-items: center;
      gap: 4px;
      width: fit-content;
      padding: 4px 8px;
      border-radius: 5px;
      background-color: #FF6568;
      color: #FFF;
      cursor: pointer;
    }
  }

  .dropdown-button {
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 12px;
    transition: .3s;
    cursor: pointer;
  }
  .dropdown-button:hover {
    background: rgba(0, 0, 0, 0.16);
  }
  .menu_drop_down {
    margin-top: -10px;
    position: absolute;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 8px 16px -4px rgba(0, 0, 0, 0.20);
    border-radius: 16px;
    z-index: 99;
    background-color: white;
    overflow: hidden;
    right: 0;

    .option {
      padding: 12px 20px;
      display: flex;
      gap: 16px;
      cursor: pointer;
      transition: .3s;

      &:hover {
        background-color: #e6e6e6;
      }
    }
  }
</style>